export default __webpack_public_path__ + "static/media/Puntos-interes.92aa8c54.svg";